import { Col, Row } from '@ahmdigital/ui';

import AccordionSection from '../../../../src/client/components/sections/accordion-section';
import data from '../../data';

const TopTips = () => (
  <Row isBoxed>
    <Col df={12}>
      <Row>
        <Col dfOffset={2} df={8} sm={12} smOffset={0}>
          <AccordionSection accordionId="top-tips-privacy-security" items={data} title="Top tips" image={undefined} />
        </Col>
      </Row>
    </Col>
  </Row>
);

export default TopTips;
